// alterado - revisado

import React from 'react'

import MESSAGE from '../../business-const/Message/Message'

import {
    ListRadioGroup,
} from '../../business-components/RadioGroup/RadioGroup'

import simNaoList from '../List/simNaoList'

export const SimNaoRadioGroup = props => {
    return (
        <ListRadioGroup
            list={simNaoList}
            {...props}
        />
    )
}

export const SimNaoRadioGroupRequired = props => {
    return (
        <>
            <SimNaoRadioGroup
                {...props}
            />
            {props.value ? '' : MESSAGE().campoObrigatorioRadioGroup}
        </>
    )
}